import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Col, Row, Card, Breadcrumb, Table, Alert, Badge } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { MdOutlineDatasetLinked } from "react-icons/md";
import { FiLink } from "react-icons/fi";
import { GoUnlink } from "react-icons/go";
import { TbUnlink, TbLinkPlus } from "react-icons/tb";
import { InputText } from 'primereact/inputtext';

const ClientLinksPage = () => {
    const { accessToken } = useAuth();
    const [links, setLinks] = useState([]);
    const [counts, setCounts] = useState({
        totalLinks: 0,
        totalRegistrationTrue: 0,
        totalActiveRegistrationFalse: 0,
        totalInactive: 0,
    });
    // Split from the table's loading state — previously a single `loading` flag
    // gated an early `return <div>Loading...</div>` for the WHOLE page, so clicking
    // Generate blanked out the entire screen (table + the still-open Dialog) instead
    // of just showing a spinner on the Generate button.
    const [tableLoading, setTableLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [generatedLink, setGeneratedLink] = useState('');
    const [dialogVisible, setDialogVisible] = useState(false);
    const [clientName, setClientName] = useState('');
    const [step, setStep] = useState(1); // 1 = input name, 2 = show link
    const [generatedExpiresAt, setGeneratedExpiresAt] = useState(null);
    const [generateError, setGenerateError] = useState('');
    // Fetch all links on component mount
    useEffect(() => {
        fetchLinks();
    }, []);

    const fetchLinks = async () => {
        setTableLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/ClientAuthRoutes/all-links`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setLinks(response.data.links || []); // Fallback to empty array if null
            setCounts(response.data.counts || {
                totalLinks: 0,
                totalRegistrationTrue: 0,
                totalActiveRegistrationFalse: 0,
                totalInactive: 0,
            });
        } catch (error) {
            console.error('Error fetching links:', error);
            setLinks([]); // Ensure links is at least an empty array
        } finally {
            setTableLoading(false);
        }
    };


    const handleGenerateClick = () => {
        setStep(1); // First step is asking for client name
        setClientName('');
        setGeneratedExpiresAt(null);
        setGenerateError('');
        setDialogVisible(true);
    };


    const submitClientName = async () => {
        if (!clientName.trim()) {
            return;
        }
        setGenerating(true);
        setGenerateError('');
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/ClientAuthRoutes/generate-link`,
                { Client_name: clientName },
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            setGeneratedLink(response.data.link || '');
            setGeneratedExpiresAt(response.data.expiresAt || null);
            setStep(2); // Move to link display
            // Await so the table is confirmed refreshed (and any fetch error is visible)
            // instead of firing-and-forgetting a request that could race with re-renders.
            await fetchLinks();
        } catch (error) {
            console.error('Error generating link:', error);
            setGenerateError(error.response?.data?.message || 'Failed to generate the link. Please try again.');
        } finally {
            setGenerating(false);
        }
    };

    const [copySuccess, setCopySuccess] = useState('');

    const handleCopyLink = () => {
        if (generatedLink) {
            navigator.clipboard.writeText(generatedLink).then(() => {
                setCopySuccess('Link copied successfully!');
            }).catch((error) => {
                console.error('Failed to copy link:', error);
                setCopySuccess('Failed to copy the link.');
            });
        }
    };
    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={6} lg={6} className="mb-4">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Client Registration Links</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col sm={6} lg={6} className="mb-4 text-end">
                        <Button
                            onClick={handleGenerateClick}
                            label="Generate New Link"
                            icon="pi pi-link"
                            className="border-0 py-2"
                            severity='primary'
                        />
                    </Col>
                    <Col sm={12} lg={12} className="mb-3">
                        <ul className='justify-content-start taskperform ticketlist'>
                            <li className='dashboard_card'>
                                <Card className="shadow-0 h-100">
                                    <Card.Header>
                                        <div className="d-flex justify-content-between">
                                            <div className='repTItle'>
                                                <span className="d-block">Total Links:</span>
                                                <span className="d-block h4 mt-3">{counts.totalLinks}</span>
                                            </div>
                                            <div className='hrshortdata'>
                                                <span style={{ color: '#cdf0ff' }}><TbLinkPlus /></span>
                                            </div>
                                        </div>
                                    </Card.Header>
                                </Card>
                            </li>
                            <li className='dashboard_card'>
                                <Card className="shadow-0 h-100">
                                    <Card.Header>
                                        <div className="d-flex justify-content-between">
                                            <div className='repTItle'>
                                                <span className="d-block">Active Registration False:</span>
                                                <span className="d-block h4 mt-3">{counts.totalActiveRegistrationFalse}</span>
                                            </div>
                                            <div className='hrshortdata'>
                                                <span style={{ color: '#fff3cf' }}><TbUnlink /></span>
                                            </div>
                                        </div>
                                    </Card.Header>
                                </Card>
                            </li>
                            <li className='dashboard_card'>
                                <Card className="shadow-0 h-100">
                                    <Card.Header>
                                        <div className="d-flex justify-content-between">
                                            <div className='repTItle'>
                                                <span className="d-block">Registration True:</span>
                                                <span className="d-block h4 mt-3">{counts.totalRegistrationTrue}</span>
                                            </div>
                                            <div className='hrshortdata'>
                                                <span style={{ color: '#dfffe1' }}><FiLink /></span>
                                            </div>

                                        </div>
                                    </Card.Header>
                                </Card>
                            </li>
                            <li className='dashboard_card'>
                                <Card className="shadow-0 h-100">
                                    <Card.Header>
                                        <div className="d-flex justify-content-between">
                                            <div className='repTItle'>
                                                <span className="d-block">Inactive Links:</span>
                                                <span className="d-block h4 mt-3">{counts.totalInactive}</span>
                                            </div>
                                            <div className='hrshortdata'>
                                                <span style={{ color: '#ffeeee' }}><GoUnlink /></span>
                                            </div>
                                        </div>
                                    </Card.Header>
                                </Card>
                            </li>
                        </ul>
                    </Col>

                    <Col sm={12} lg={12}>
                        <Card>
                            <Card.Body className='gerdatatable_link'>
                                <div>
                                    {tableLoading && (
                                        <div className="text-center text-muted py-2">
                                            <i className="pi pi-spin pi-spinner me-2" />
                                            Refreshing links…
                                        </div>
                                    )}
                                    <Table hover striped bordered responsive size='sm'>
                                        <thead>
                                            <tr className='table-primary sticky-top'>
                                                <th>Link Generated For</th>
                                                <th>Link URL</th>
                                                <th className="text-center">Status</th>
                                                <th className="text-center">Registration</th>
                                                <th className="text-center" style={{ width: '150px', whiteSpace: 'nowrap' }}>Expires</th>
                                                <th className="text-center" style={{ width: '150px', whiteSpace: 'nowrap' }}>Last Updated</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {links && links.length > 0 ? (
                                                links.map((rowData, index) => {
                                                    const isExpired = rowData?.expires_at && new Date(rowData.expires_at) < new Date();
                                                    return (
                                                    <tr key={index}>
                                                        {/* Link URL */}
                                                        <td>
                                                            {rowData.Client_name || 'NA'}
                                                        </td>
                                                        <td>
                                                            {rowData?.link_url ? (
                                                                <span className="text-blue-500 underline">
                                                                    {rowData.link_url}
                                                                </span>
                                                            ) : (
                                                                'N/A'
                                                            )}
                                                        </td>
                                                        {/* Status */}
                                                        <td className="text-center">
                                                            <Badge
                                                                bg={
                                                                    rowData?.link_status === 'Active' && !isExpired
                                                                        ? 'success'
                                                                        : 'danger'
                                                                }
                                                            >
                                                                {rowData?.link_status === 'Active' && isExpired ? 'Expired' : (rowData?.link_status || 'Unknown')}
                                                            </Badge>
                                                        </td>
                                                        {/* Registration */}
                                                        <td className="text-center">
                                                            <span
                                                                className={`fw-bold ${rowData?.registration
                                                                    ? 'text-success'
                                                                    : 'text-danger'
                                                                    }`}
                                                            >
                                                                {rowData?.registration ? 'True' : 'False'}
                                                            </span>
                                                        </td>
                                                        {/* Expires */}
                                                        <td className="text-center">
                                                            {rowData?.expires_at ? (
                                                                new Intl.DateTimeFormat('en-GB', {
                                                                    day: '2-digit',
                                                                    month: '2-digit',
                                                                    year: 'numeric',
                                                                }).format(new Date(rowData.expires_at))
                                                            ) : (
                                                                'N/A'
                                                            )}
                                                        </td>
                                                        {/* Last Updated */}
                                                        <td className="text-center">
                                                            {rowData?.updatedAt ? (
                                                                new Intl.DateTimeFormat('en-GB', {
                                                                    day: '2-digit',
                                                                    month: '2-digit',
                                                                    year: 'numeric',
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    hour12: false,
                                                                }).format(new Date(rowData.updatedAt))
                                                            ) : (
                                                                'N/A'
                                                            )}
                                                        </td>
                                                    </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
            <Dialog
                visible={dialogVisible}
                onHide={() => setDialogVisible(false)}
                header={step === 1 ? "Enter Client Name" : "Generated Registration Link"}
                style={{ width: '340px' }}
            >
                {step === 1 ? (
                    <>
                        <p>Please enter the client name for which the registration link will be generated:</p>
                        <InputText
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            placeholder="Client Name"
                            className="w-100"
                        />
                        {generateError && (
                            <Alert variant="danger" className='py-1 text-center mt-2'>{generateError}</Alert>
                        )}
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                label="Generate"
                                icon="pi pi-check"
                                onClick={submitClientName}
                                severity="success"
                                loading={generating}
                                disabled={generating}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <p>Here is the newly generated registration link:</p>
                        {generatedLink ? (
                            <>
                                <a
                                    href={generatedLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 underline linkgenerated"
                                >
                                    {generatedLink}
                                </a>
                                {generatedExpiresAt && (
                                    <p className="text-muted mt-2 mb-0" style={{ fontSize: '12px' }}>
                                        Expires: {new Date(generatedExpiresAt).toLocaleString()}
                                    </p>
                                )}
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Button
                                        label="Copy Link"
                                        icon="pi pi-copy"
                                        className="border-0 py-2 my-3"
                                        onClick={handleCopyLink}
                                        severity='success'
                                    />
                                </div>
                                {copySuccess && (
                                    <Alert variant="success" className='py-1 text-center'>{copySuccess}</Alert>
                                )}
                            </>
                        ) : (
                            <Alert variant="danger" className='py-1 text-center'>No link generated yet.</Alert>
                        )}
                    </>
                )}
            </Dialog>
        </>
    );
};

export default ClientLinksPage;
